<h1 mat-dialog-title>{{ data }} Continue?</h1>

<div mat-dialog-actions class="row text-center">
  <div class="col-md-12 text-center">
    <button class="btn-product margin-right-6" [mat-dialog-close]="true">Confirm</button>
    <button class="btn-product" [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
  </div>
</div>
